import { useMemo } from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

export function useRouter() {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      reload: () => window.location.reload(),
      push: (options: string | { pathname: string; query?: Record<string, string> }) => {
        if (typeof options === "string") {
          navigate(options);
        } else {
          const { pathname, query } = options;
          const search = query ? `?${createSearchParams(query)}` : "";
          navigate(`${pathname}${search}`);
        }
      },
      replace: (href: string) => navigate(href, { replace: true }),
    }),
    [navigate]
  );

  return router;
}
